// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3FbBJ","choiceBoxes":"toolbarselects_choiceBoxes__3r6SJ","simpleField":"toolbarselects_simpleField__1rEi7"};